namespace TabAurous.Administration {
    export interface FreightRow {
        FreightId?: number;
        FreightCode?: string;
        FreightName?: string;
        LedgerId?: number;
        UserId?: string;
        Password?: string;
        ApiEndpoint?: string;
        ApiKey?: string;
        ClientSecret?: string;
    }

    export namespace FreightRow {
        export const idProperty = 'FreightId';
        export const nameProperty = 'FreightCode';
        export const localTextPrefix = 'Administration.Freight';
        export const lookupKey = 'Administration.Freight';

        export function getLookup(): Q.Lookup<FreightRow> {
            return Q.getLookup<FreightRow>('Administration.Freight');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            FreightId = "FreightId",
            FreightCode = "FreightCode",
            FreightName = "FreightName",
            LedgerId = "LedgerId",
            UserId = "UserId",
            Password = "Password",
            ApiEndpoint = "ApiEndpoint",
            ApiKey = "ApiKey",
            ClientSecret = "ClientSecret"
        }
    }
}
